import { JSONSchemaType } from './JsonSchemaType';
import { NAME_PATTERN } from './constants';

export const LATEST_PARAMETER_RESOLVER_SCHEMA_VERSION = '2023-01-05.1';
/**
 * CHANGELOG
 * ====================================
 *
 * - 2023-01-05.1: Initial version.
 */

export type ModelParameterResolver = {
  // Matches the name of the model parameter.
  name: string;
  expression: string;
};

export type ParameterResolver = {
  schemaVersion: string;
  modelParameters: Array<ModelParameterResolver>;
};

export const parameterResolverSchema: JSONSchemaType<ParameterResolver> = {
  type: 'object',
  properties: {
    schemaVersion: {
      type: 'string',
      pattern: '^\\d{4}-\\d{2}-\\d{2}\\.\\d+$',
    },
    modelParameters: {
      type: 'array',
      items: {
        type: 'object',
        properties: {
          name: { type: 'string', pattern: NAME_PATTERN },
          expression: { type: 'string' },
        },
        additionalProperties: false,
        required: ['name', 'expression'],
      },
    },
  },
  additionalProperties: false,
  required: ['schemaVersion', 'modelParameters'],
} as const;
